import { gql } from '@apollo/client';

export const ALL_CASES = gql`
  query AllCases($input: AllCasesInput) {
    cases: allCases(input: $input) {
      aggregate {
        count
      }
      edges {
        node {
          id
          caseId
          consultationsCount
          nextAppointment {
            id
            date
            time
          }
          peopleProfile {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;
